module.exports = __webpack_public_path__ + "static/media/CTLA_9-178w.d840af27.jpg";